import { jsxs as h, jsx as e } from "react/jsx-runtime";
import { memo as l, useState as g } from "react";
import t from "styled-components";
import { skeletonLoadingAnimation as f } from "../constants/style.js";
import i from "../layout/flex-view.js";
const p = t(i)`
  animation: ${f} 2s linear infinite;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`, L = t(i)`
  overflow: hidden;
  position: relative;
`, j = l(({ borderRadius: n = 0, withLoader: r, ...o }) => {
  const { width: a, height: s } = o, [d, m] = g(!0);
  return /* @__PURE__ */ h(L, { $borderRadius: n, $width: a, $height: s, children: [
    d && r && /* @__PURE__ */ e(p, { $inherit: !0 }),
    /* @__PURE__ */ e("img", { onLoad: () => {
      m(!1);
    }, ...o })
  ] });
});
export {
  j as default
};
//# sourceMappingURL=image.js.map
